<forge-card class="chart" no-padding>
  <forge-toolbar>
    <div slot="start" fxLayout="column">
      <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
      @if (isLoaded) {
        <truncate-text class="forge-typography--subheading1" [allowHtml]="true" fxFlex="100"
          [mainText]="ChartSubtitle">
        </truncate-text>
      }
    </div>

    <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
      telemetry="Chart settings" aria-label="chart settings">
      <forge-tooltip>Chart settings</forge-tooltip>
      <forge-icon name="settings"></forge-icon>
    </forge-icon-button>
  </forge-toolbar>

  <div class="metadata-padding">
    @if (isLoaded) {
      <div>
        @if (showChart) {
          <chartjs-container [config]="chartConfig">
          </chartjs-container>
        }
        @if (!chartHasData) {
          <div>
            Not enough data to display graph
          </div>
        }
        @if (errorMessage) {
          <div class="error-red">
            {{errorMessage}}
          </div>
        }
      </div>
    }

    @if (!isLoaded) {
      <busy-indicator [chart]="true"></busy-indicator>
    }

    @if (showChart) {
      <div fxLayout="row" fxLayoutAlign="end center">
        <command-bar telemetry="Menu-GenericChart" [commands]="commands"></command-bar>
      </div>
    }
  </div>
</forge-card>
